import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cities: [],
};

export const citiesSlice = createSlice({
  name: "cities",
  initialState,
  reducers: {
    persistCities: (state, action) => {
      if (state.cities.length > 0) {
        return;
      }

      state.cities.push(action.payload);
    },
  },
});

export const { persistCities } = citiesSlice.actions;

export const selectCities = (state) => state.cities;
export default citiesSlice.reducer;
